import {ChemicalFormatType} from 'chemistry/ChemistryConstants';
import FileStates from 'FileStates';
import {writeFragmentsToCache} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import notifications from 'notifications';
import {getStore} from 'redux-stores/Store';

import * as MoleculeDAO from './MoleculeDAO';
import {getCurrentVersionId} from './MoleculeUtil';
import {updateMoleculeVersion} from './MoleculeVersionReduxActions';

export async function resetToVersion(moleculeId: string, moleculeVersionId: string): Promise<void> {
  const currentVersionId = await getCurrentVersionId(moleculeId);
  const response = await MoleculeDAO.resetToVersion(moleculeId, moleculeVersionId, currentVersionId);
  getStore().dispatch(updateMoleculeVersion(response.molecule.id, response.molecule.currentVersion.id));
  writeFragmentsToCache(getFragmentWrapper('UpdateMoleculeVersionResponse'), [response.molecule]);
  notifications.success('Successfully reset molecule version');
}

export async function createMolecule(
  name: string,
  folderId: string,
  structureFormat: ChemicalFormatType,
  chemicalStructure: string,
  schemaId: string | null = null,
  studyIds?: Array<string>
): Promise<void> {
  const molecule = await MoleculeDAO.createMolecule(
    name,
    folderId,
    structureFormat,
    chemicalStructure,
    schemaId,
    studyIds
  );
  writeFragmentsToCache(getFragmentWrapper('Molecule'), [molecule]);
  FileStates.get().openFolderItem(molecule.id);
}

export async function updateChemicalStructure(
  moleculeId: string,
  expectedCurrentVersionId: string,
  structureFormat: ChemicalFormatType,
  chemicalStructure: string
): Promise<void> {
  const molecule = await MoleculeDAO.updateChemicalStructure(
    moleculeId,
    expectedCurrentVersionId,
    structureFormat,
    chemicalStructure
  );
  writeFragmentsToCache(getFragmentWrapper('Molecule'), [molecule]);
  getStore().dispatch(updateMoleculeVersion(molecule.id, molecule.currentVersion.id));
  notifications.success('Successfully updated chemical structure');
  FileStates.get().openFolderItem(moleculeId);
}
